export enum FlagToggle {
  On = 'ON',
  Off = 'OFF',
}
